import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PRICE, PRODUCT_TM } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="ultima-pregunta" className="bg-navy-deep" data-id="element-49" data-mp="c83pjkbwtm5j">
      <div className="mx-auto max-w-3xl px-3 py-5 text-center sm:px-6 sm:py-7" data-id="element-50" data-mp="84e2x0espen5">
        <Reveal data-id="element-51" data-mp="m46nedzqaymo">
          <h2 id="ultima-pregunta" className="font-display text-lg uppercase leading-tight text-white sm:text-2xl" data-id="element-52" data-mp="m3nhxwr9m2pj">
            Una última pregunta
          </h2>
          <p className="mx-auto mt-1 max-w-2xl font-body text-[0.8rem] leading-snug text-white/80 sm:text-sm" data-id="element-53" data-mp="vtghu0i1otdy">
            Puedes seguir guardando videos, buscando tutoriales y tratando de
            descubrir por tu cuenta qué aprender primero...{' '}
            <span className="font-bold text-white" data-id="element-54" data-mp="zwd1zvn8gxk0">
              O puedes comenzar hoy con una ruta organizada desde los
              fundamentos de la energía solar hasta el dimensionamiento,
              instalación, mantenimiento y primeros pasos profesionales.
            </span>
          </p>
          <p className="mt-1 font-script text-2xl leading-tight text-solar sm:text-3xl" data-id="element-55" data-mp="2m2udjfd1sfbl">
            No necesitas ser experto para comenzar. Necesitas saber qué aprender
            primero.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mt-2.5 rounded-xl border-2 border-solar bg-white p-3 sm:p-4" data-id="element-56" data-mp="2v4amdio7s9dp">
          <h3 className="font-display text-base uppercase leading-tight text-navy sm:text-2xl" data-id="element-57" data-mp="30111o3s730y2">
            ☀️ {PRODUCT_TM}
          </h3>
          <p className="mt-0.5 font-condensed text-lg uppercase tracking-wide text-azure sm:text-2xl" data-id="element-58" data-mp="39sf4oljcuivy">
            6 Módulos + 5 Bonos incluidos
          </p>
          <p className="mt-1 text-[0.72rem] font-bold uppercase text-steel sm:text-[0.78rem]" data-id="element-59" data-mp="3et2xncr599st">
            🎁 Valor de los bonos:{' '}
            <span className="line-through decoration-azure decoration-2" data-id="element-60" data-mp="1jocysg5m13xl">
              {BONUS_VALUE}
            </span>
          </p>
          <p className="text-[0.74rem] font-black uppercase text-azure sm:text-[0.8rem]" data-id="element-61" data-mp="1eq1q48r1wzgy">
            🔥 Hoy los 5 bonos: Gratis
          </p>

          <p className="mt-2 text-[0.66rem] font-black uppercase tracking-[0.24em] text-steel sm:text-[0.72rem]" data-id="element-62" data-mp="1sirmn747hmsb">
            Precio especial:
          </p>
          <p className="font-display text-4xl leading-none text-navy sm:text-5xl" data-id="element-63" data-mp="22drya65ndkzv">
            ☀️ {PRICE} ☀️
          </p>
          <p className="text-[0.66rem] font-semibold uppercase tracking-wide text-steel sm:text-[0.72rem]" data-id="element-64" data-mp="1xf897wvrbt3a">
            Pago único • Acceso Digital
          </p>

          <div className="mt-2.5 flex flex-col items-center gap-1" data-id="element-65" data-mp="27de8e6q6il4g">
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-66" data-mp="27c35080nbfdv">
              🔥 ¡SÍ! QUIERO EL SISTEMA COMPLETO POR {PRICE}
            </CtaButton>
            <p className="text-[0.66rem] font-semibold uppercase tracking-wide text-steel sm:text-[0.72rem]" data-id="element-67" data-mp="d0y8dnnz8381">
              Acceso Inmediato • Entrega Digital
            </p>
            <p className="flex items-center gap-1.5 text-[0.66rem] font-bold uppercase tracking-wide text-steel sm:text-[0.72rem]" data-id="element-68" data-mp="6y32o7vncmaq">
              <ShieldCheckIcon size={13} className="text-gold" data-id="element-69" data-mp="3pargx3effu50" />
              🛡️ Garantía de Devolución de 30 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}